document.addEventListener("DOMContentLoaded", () => {
    let form = document.querySelector('.calculation__send');
    let finalPopup = document.querySelector('.final-popup');
    let finalPopupForm = document.querySelector('.final-popup__form');
    let popupConfirmForm = document.querySelector('.confirm-phone-popup__form');
    let popupConfirm = document.querySelector('.confirm-phone-popup');
    let successPopup = document.querySelector('.calculation-success-popup');
    let codeInput = document.querySelector(".confirm-phone-popup__in");
    let successPopupClose = document.querySelector('.calculation-success-popup__btn');
    let finalPopupClose = document.querySelector('.final-popup__close');
    let popupCancelButton = document.querySelector('.confirm-phone-popup__close');

    function closePopup() {
        finalPopup.classList.remove('visible');
        popupConfirm.classList.remove('visible');
        successPopup.classList.remove('visible');
        popupConfirmForm.classList.remove('visible');
    }

    popupCancelButton.addEventListener('click', () => {
        closePopup();
    });

    finalPopupClose.addEventListener('click', () => {
        closePopup()
    });

    successPopupClose.addEventListener('click', () => {
        closePopup()
    });


    let timeLeft = 58; // Оставшееся время в секундах
    let timerInterval; // Переменная для хранения интервала


    form.addEventListener('submit', (e) => {
        e.preventDefault();
        const termSelect = document.getElementById("term");
        const rangeInput = document.getElementById("sum");
        const annualInput = document.getElementById("annual");
        const monthPayValue = document.querySelector(".month-pay-value");

        document.querySelector(".final-popup__term").value = termSelect.options[termSelect.selectedIndex].text;
        document.querySelector(".final-popup__annual-rate").value = annualInput.value;
        document.querySelector(".final-popup__pay-month").value = monthPayValue.textContent;
        document.querySelector(".final-popup__credit-sum").value = rangeInput.value;

        finalPopup.classList.add('visible');

    });


    finalPopupForm.addEventListener('submit', (e) => {
        e.preventDefault();
        finalPopup.classList.remove('visible');
        popupConfirm.classList.add('visible');
        e.preventDefault();
        let formData = new FormData(finalPopupForm);


        fetch(document.querySelector('body').dataset.ajax, {
            method: 'POST',
            body: formData,
            headers: {
                'Accept': 'application/json',
            }
        })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    console.log('Данные успешно отправлены:', data);
                } else {
                    console.error('Ошибка при отправке данных:', data);
                }
            })
            .catch(error => {
                console.error('Произошла ошибка:', error);
            });

        finalPopupForm.classList.remove('visible');
        popupConfirm.classList.add('visible');
        startTimer();
    });




    popupConfirmForm.addEventListener('submit', (e) => {

        e.preventDefault();
        const formData = new FormData(finalPopupForm);

        formData.set('action', 'sms_code');
        formData.set('code', codeInput.value);
        popupConfirmForm.querySelector('button').disabled = true;
        popupConfirmForm.querySelector('button').textContent = 'Отправка...';
        fetch(document.querySelector('body').dataset.ajax, {
            method: 'POST',
            body: formData,
            headers: {
                'Accept': 'application/json',
            }
        })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    console.log('Данные успешно отправлены:', data);
                    finalPopupForm.reset();
                    popupConfirm.classList.remove('visible');
                    popupConfirmForm.classList.remove('visible');
                    finalPopup.classList.remove('visible');
                    successPopup.classList.add('visible');
                    popupConfirmForm.querySelector('button').disabled = false; // Разблокируем кнопку
                    popupConfirmForm.querySelector('button').textContent = 'Отправить';
                } else {
                    codeInput.classList.add('error');
                    console.error('Ошибка при отправке данных:', data);
                }
            })
            .catch(error => {
                codeInput.classList.add('error');
                console.error('Произошла ошибка:', error);
            });
    });



















    const resendButton = document.getElementById('resendButton');
    const timerElement = document.getElementById('timer');
    function updateTimer() {
        const minutes = Math.floor(timeLeft / 60);
        const seconds = timeLeft % 60;
        timerElement.textContent = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    }
    function startTimer() {
        timerInterval = setInterval(() => {
            timeLeft--;
            updateTimer();

            // Когда время истекает, изменяем текст и отключаем таймер
            if (timeLeft <= 0) {
                clearInterval(timerInterval);
                timerElement.textContent = '00:00'; // Текст таймера
                resendButton.textContent = 'Отправить повторно'; // Изменяем текст на кнопке
                resendButton.addEventListener('click', resendClickHandler); // Добавляем обработчик клика
            }
        }, 1000);
    }
});